import React, { useEffect, useState, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import AdBlockerDetector from './components/AdBlockerDetector';
import { Toaster } from './components/ui/sonner';

// Lazy load route components for code splitting
const TopicDetail = lazy(() => import('./components/TopicDetail'));
const Quiz = lazy(() => import('./components/Quiz'));
const Admin = lazy(() => import('./components/Admin'));
const Bookmarks = lazy(() => import('./components/Bookmarks'));
const Explore = lazy(() => import('./components/Explore'));
const TemplateBuilder = lazy(() => import('./components/TemplateBuilder'));
const Privacy = lazy(() => import('./components/Privacy'));
const Terms = lazy(() => import('./components/Terms'));
const Cookies = lazy(() => import('./components/Cookies'));
const About = lazy(() => import('./components/About'));

// Loading skeleton component
const LoadingScreen = () => (
  <div className="min-h-screen bg-cream dark:bg-velvet flex items-center justify-center">
    <div className="text-center">
      <div className="inline-block w-12 h-12 bg-gradient-to-br from-sapphire to-gold rounded-lg animate-softPulse mb-4"></div>
      <p className="text-sapphire dark:text-cream-light">Loading...</p>
    </div>
  </div>
);

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [adBlockerDetectionEnabled, setAdBlockerDetectionEnabled] = useState(true);

  useEffect(() => {
    // Initialize dark mode based on user preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const savedMode = localStorage.getItem('darkMode');
    const isDark = savedMode !== null ? savedMode === 'true' : prefersDark;
    
    setIsDarkMode(isDark);
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    // Load anti-adblocker setting from localStorage
    const savedAdBlockerSetting = localStorage.getItem('antiAdBlockerEnabled');
    if (savedAdBlockerSetting !== null) {
      setAdBlockerDetectionEnabled(savedAdBlockerSetting === 'true');
    }

    // Listen for storage changes (when updated from Admin panel)
    const handleStorageChange = (e) => {
      if (e.key === 'antiAdBlockerEnabled') {
        setAdBlockerDetectionEnabled(e.newValue === 'true');
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AdBlockerDetector isDarkMode={isDarkMode} enabled={adBlockerDetectionEnabled} />
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/topic/:id" element={<TopicDetail />} />
            <Route path="/quiz/:id" element={<Quiz />} />
            <Route path="/bookmarks" element={<Bookmarks />} />
            <Route path="/praneethsecurepanel143admin" element={<Admin />} />
            <Route path="/templates" element={<TemplateBuilder />} />
            <Route path="/praneethsecurepanel143admin/template-builder" element={<TemplateBuilder />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </Suspense>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;